const arcturus = {
    title: "Computer Vision Intern",
    company: "Arcturus Business Solutions",
  };
  
  export default arcturus;